(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const cartPage = document.querySelector('.cart-page');
    const cartForm = document.getElementById('cart-form');
    const checkoutButton = document.querySelector('.cart-summary__checkout');
    const statusMessage = document.querySelector('[data-cart-status]');
    const overlay = document.querySelector('[data-cart-overlay]');
    const overlayText = document.querySelector('.cart-page__overlay-text');
    const qtyBtns = document.querySelectorAll('.cart-item__qty-btn');

    const restrictedProductTitles = ['Personalised Pack', 'Essential One'];
    let checkoutInProgress = false;
    let cartNormalizationInProgress = false;

    function setCheckoutState(isDisabled, message, isError) {
      if (checkoutButton) {
        checkoutButton.disabled = isDisabled;
        checkoutButton.setAttribute('aria-busy', isDisabled ? 'true' : 'false');
      }

      if (overlay && cartPage) {
        if (isDisabled) {
          cartPage.classList.add('is-busy');
          overlay.hidden = false;
          overlay.setAttribute('aria-hidden', 'false');
        } else {
          cartPage.classList.remove('is-busy');
          overlay.hidden = true;
          overlay.setAttribute('aria-hidden', 'true');
        }
      }

      if (overlayText && message) {
        overlayText.textContent = message;
      } else if (overlayText) {
        overlayText.textContent = 'Updating your basket...';
      }

      if (!statusMessage) return;

      if (message) {
        statusMessage.textContent = message;
        statusMessage.classList.add('is-visible');
      } else {
        statusMessage.textContent = '';
        statusMessage.classList.remove('is-visible');
      }

      if (isError) {
        statusMessage.classList.add('is-error');
      } else {
        statusMessage.classList.remove('is-error');
      }
    }

    function buildRestrictedCartUpdates(items) {
      const updates = {};
      const restrictedGroups = {};

      items.forEach(function(item, index) {
        if (restrictedProductTitles.indexOf(item.product_title) === -1) return;

        if (!restrictedGroups[item.product_title]) {
          restrictedGroups[item.product_title] = [];
        }

        restrictedGroups[item.product_title].push({
          item: item,
          index: index
        });
      });

      Object.keys(restrictedGroups).forEach(function(productTitle) {
        const matchingItems = restrictedGroups[productTitle];
        // Shopify returns the most recently added cart line first for these items, so the first line wins.
        const latestItem = matchingItems[0];

        matchingItems.forEach(function(entry) {
          if (entry.index === latestItem.index) {
            if (entry.item.quantity > 1) {
              updates[entry.item.key] = 1;
            }
          } else {
            updates[entry.item.key] = 0;
          }
        });
      });

      return updates;
    }

    async function normalizeRestrictedProducts() {
      const cartResponse = await fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js', {
        method: 'GET',
        headers: {
          'Accept': 'application/json'
        }
      });

      if (!cartResponse.ok) {
        throw new Error('Unable to load cart');
      }

      const cart = await cartResponse.json();
      const updates = buildRestrictedCartUpdates(cart.items || []);

      if (Object.keys(updates).length === 0) {
        return false;
      }

      const updateResponse = await fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/update.js' : '/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ updates: updates })
      });

      if (!updateResponse.ok) {
        throw new Error('Unable to update cart');
      }

      await updateResponse.json();
      return true;
    }

    async function normalizeRestrictedProductsOnLoad() {
      if (!cartForm || cartNormalizationInProgress) return;

      cartNormalizationInProgress = true;
      setCheckoutState(true, 'Updating your basket...', false);

      try {
        const cartChanged = await normalizeRestrictedProducts();

        if (cartChanged) {
          window.location.reload();
          return;
        }

        setCheckoutState(false, '', false);
      } catch (error) {
        setCheckoutState(false, 'We could not validate your basket. Please try again.', true);
      } finally {
        cartNormalizationInProgress = false;
      }
    }

    async function handleCheckout(event) {
      if (checkoutInProgress || cartNormalizationInProgress) {
        event.preventDefault();
        return;
      }

      event.preventDefault();

      checkoutInProgress = true;
      setCheckoutState(true, 'Checking your basket...', false);

      try {
        const cartChanged = await normalizeRestrictedProducts();

        if (cartChanged) {
          setCheckoutState(true, 'Updating your basket...', false);
        }

        setCheckoutState(true, '', false);

        const checkoutInput = document.createElement('input');
        checkoutInput.type = 'hidden';
        checkoutInput.name = 'checkout';
        checkoutInput.value = checkoutButton && checkoutButton.textContent ? checkoutButton.textContent.trim() : 'Checkout';
        cartForm.appendChild(checkoutInput);
        cartForm.submit();
      } catch (error) {
        checkoutInProgress = false;
        setCheckoutState(false, 'We could not validate your basket. Please try again.', true);
      }
    }

    qtyBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        const action = this.dataset.action;
        const index = this.dataset.index;
        const input = document.querySelector('.cart-item__qty-input[data-index="' + index + '"]');
        let value = parseInt(input.value);
        
        if (action === 'increase') {
          input.value = value + 1;
        } else if (action === 'decrease' && value > 0) {
          input.value = value - 1;
        }
        
        // Auto-submit after a short delay
        clearTimeout(window.cartUpdateTimeout);
        window.cartUpdateTimeout = setTimeout(function() {
          cartForm.submit();
        }, 800);
      });
    });

    if (cartForm && checkoutButton) {
      checkoutButton.addEventListener('click', handleCheckout);
    }

    if (cartForm) {
      normalizeRestrictedProductsOnLoad();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  // Filter sidebar toggle
  const filtersOpen = document.querySelector('[data-filters-open]');
  const filtersClose = document.querySelector('[data-filters-close]');
  const filters = document.querySelector('[data-filters]');
  const overlay = document.querySelector('[data-filters-overlay]');
  
  if (filtersOpen && filters) {
    filtersOpen.addEventListener('click', () => {
      filters.classList.add('is-open');
      overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
  }
  
  if (filtersClose && filters) {
    filtersClose.addEventListener('click', () => {
      filters.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }
  
  if (overlay) {
    overlay.addEventListener('click', () => {
      filters.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.body.style.overflow = '';
    });
  }
  
  // Sort select
  const sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', (e) => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', e.target.value);
      window.location.href = url.toString();
    });
  }
  
  // Filter form auto-submit
  const filterForm = document.querySelector('[data-filter-form]');
  if (filterForm) {
    filterForm.addEventListener('change', (e) => {
      if (e.target.type === 'checkbox' || e.target.type === 'number') {
        // Small delay for number inputs
        if (e.target.type === 'number') {
          clearTimeout(filterForm.submitTimeout);
          filterForm.submitTimeout = setTimeout(() => filterForm.submit(), 500);
        } else {
          filterForm.submit();
        }
      }
    });
  }

  // Plan picker modal + AJAX add to cart
  const planModal = document.querySelector('[data-plan-modal]');
  const planTriggers = document.querySelectorAll('[data-plan-modal-trigger]');
  const modalCloseButtons = document.querySelectorAll('[data-plan-modal-close]');
  const modalForm = document.querySelector('[data-plan-modal-form]');
  const modalVariantInput = document.querySelector('[data-plan-modal-variant-id]');
  const modalSellingPlanInput = document.querySelector('[data-plan-modal-selling-plan]');
  const modalOptions = document.querySelector('[data-plan-modal-options]');
  const modalProductTitle = document.querySelector('[data-plan-modal-product-title]');
  const modalProductImage = document.querySelector('[data-plan-modal-image]');
  const modalSubmit = document.querySelector('[data-plan-modal-submit]');
  const addToast = document.querySelector('[data-add-toast]');
  const addToastImage = document.querySelector('[data-add-toast-image]');
  const addToastProductTitle = document.querySelector('[data-add-toast-product-title]');
  const subscriptionBenefits = planModal
    ? [
        planModal.dataset.benefitDelivery,
        planModal.dataset.benefitCancel,
        planModal.dataset.benefitShipping
      ].filter(Boolean)
    : [];
  let activeCartButton = null;
  let toastTimeoutId = null;

  function showAddToast(trigger) {
    if (!addToast || !trigger || !addToastProductTitle || !addToastImage) return;

    addToastProductTitle.textContent = trigger.dataset.productTitle || '';

    if (trigger.dataset.productImage) {
      addToastImage.style.backgroundImage = 'url("' + trigger.dataset.productImage + '")';
    } else {
      addToastImage.style.backgroundImage = '';
    }

    addToast.hidden = false;

    if (toastTimeoutId) {
      clearTimeout(toastTimeoutId);
    }

    toastTimeoutId = setTimeout(() => {
      addToast.hidden = true;
    }, 5000);
  }

  async function addToCart(payload) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload)
    });

    if (!response.ok) {
      throw new Error('Unable to add item');
    }

    return response.json();
  }

  function updateHeaderCartCount(addedQty) {
    const cartLink = document.querySelector('.header__cart');
    if (!cartLink) return;

    let countEl = cartLink.querySelector('.header__cart-count');
    const currentCount = countEl ? parseInt(countEl.textContent, 10) || 0 : 0;
    const nextCount = currentCount + addedQty;

    if (nextCount <= 0) return;

    if (!countEl) {
      countEl = document.createElement('span');
      countEl.className = 'header__cart-count';
      cartLink.appendChild(countEl);
    }

    countEl.textContent = String(nextCount);
  }

  function updateCardBadge() {
    if (!activeCartButton) return;
    const badge = activeCartButton.querySelector('.product-card__cart-badge');
    if (!badge) return;

    const currentValue = parseInt(badge.textContent, 10) || 0;
    const nextValue = currentValue + 1;

    badge.textContent = String(nextValue);
    badge.classList.remove('product-card__cart-badge--empty');
    badge.classList.add('product-card__cart-badge--in-cart');
  }

  function openPlanModal(trigger) {
    if (!planModal || !modalOptions || !modalVariantInput || !modalSellingPlanInput || !modalProductTitle || !modalProductImage) return;

    activeCartButton = trigger;
    modalVariantInput.value = trigger.dataset.variantId || '';
    modalProductTitle.textContent = trigger.dataset.productTitle || '';

    if (trigger.dataset.productImage) {
      modalProductImage.style.backgroundImage = 'url("' + trigger.dataset.productImage + '")';
      modalProductImage.style.display = '';
    } else {
      modalProductImage.style.backgroundImage = '';
      modalProductImage.style.display = 'none';
    }

    modalOptions.innerHTML = '';

    const card = trigger.closest('.product-card');
    const optionsData = card ? card.querySelectorAll('[data-plan-option]') : [];
    const sortedOptions = Array.from(optionsData)
      .map((optionData) => {
        const rawPriceCents = parseInt(optionData.dataset.planPriceCents || '0', 10);
        return {
          label: optionData.dataset.planLabel || '',
          price: optionData.dataset.planPrice || '',
          sellingPlanId: optionData.dataset.sellingPlanId || '',
          priceCents: Number.isFinite(rawPriceCents) ? rawPriceCents : Number.MAX_SAFE_INTEGER
        };
      })
      .sort((a, b) => a.priceCents - b.priceCents);

    sortedOptions.forEach((optionData, idx) => {
      const optionId = 'plan-option-' + idx + '-' + (trigger.dataset.variantId || '0');
      const label = optionData.label;
      const price = optionData.price;
      const sellingPlanId = optionData.sellingPlanId;

      const labelEl = document.createElement('label');
      labelEl.className = 'collection-plan-modal__option';
      if (sellingPlanId) {
        labelEl.classList.add('collection-plan-modal__option--subscription');
      }

      const inputEl = document.createElement('input');
      inputEl.type = 'radio';
      inputEl.name = 'plan_option';
      inputEl.id = optionId;
      inputEl.value = sellingPlanId;

      const indicatorEl = document.createElement('span');
      indicatorEl.className = 'collection-plan-modal__radio-indicator';
      indicatorEl.setAttribute('aria-hidden', 'true');

      const nameEl = document.createElement('span');
      nameEl.className = 'collection-plan-modal__option-name';
      nameEl.textContent = label;

      const priceEl = document.createElement('span');
      priceEl.className = 'collection-plan-modal__option-price';
      priceEl.textContent = price;

      const optionHeaderEl = document.createElement('div');
      optionHeaderEl.className = 'collection-plan-modal__option-header';
      optionHeaderEl.appendChild(inputEl);
      optionHeaderEl.appendChild(indicatorEl);
      optionHeaderEl.appendChild(nameEl);
      optionHeaderEl.appendChild(priceEl);

      labelEl.appendChild(optionHeaderEl);

      if (sellingPlanId && subscriptionBenefits.length > 0) {
        const benefitsEl = document.createElement('ul');
        benefitsEl.className = 'collection-plan-modal__benefits';

        subscriptionBenefits.forEach((benefitText) => {
          const benefitItemEl = document.createElement('li');
          benefitItemEl.className = 'collection-plan-modal__benefit';
          benefitItemEl.textContent = benefitText;
          benefitsEl.appendChild(benefitItemEl);
        });

        labelEl.appendChild(benefitsEl);
      }

      modalOptions.appendChild(labelEl);
    });

    const radios = modalOptions.querySelectorAll('input[name="plan_option"]');
    if (radios.length > 0) {
      radios[0].checked = true;
      modalSellingPlanInput.value = radios[0].value;
    } else {
      modalSellingPlanInput.value = '';
    }

    planModal.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closePlanModal() {
    if (!planModal) return;
    planModal.hidden = true;
    document.body.style.overflow = '';
    activeCartButton = null;
  }

  if (planModal && planTriggers.length > 0) {
    planTriggers.forEach((trigger) => {
      trigger.addEventListener('click', async () => {
        const isDirectAdd = trigger.dataset.directAdd === 'true';
        if (isDirectAdd) {
          const variantId = parseInt(trigger.dataset.variantId || '0', 10);
          if (!variantId) return;

          const payload = {
            id: variantId,
            quantity: 1
          };

          if (trigger.dataset.directSellingPlanId) {
            payload.selling_plan = parseInt(trigger.dataset.directSellingPlanId, 10);
          }

          activeCartButton = trigger;
          try {
            await addToCart(payload);
            updateCardBadge();
            updateHeaderCartCount(1);
            showAddToast(trigger);
          } catch (error) {
            window.location.href = '/cart';
          }
          return;
        }

        openPlanModal(trigger);
      });
    });

    modalCloseButtons.forEach((btn) => {
      btn.addEventListener('click', closePlanModal);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !planModal.hidden) {
        closePlanModal();
      }
    });

    if (modalOptions && modalSellingPlanInput) {
      modalOptions.addEventListener('change', (event) => {
        if (event.target && event.target.name === 'plan_option') {
          modalSellingPlanInput.value = event.target.value;
        }
      });
    }

    if (modalForm) {
      modalForm.addEventListener('submit', async (event) => {
        event.preventDefault();

        if (!modalVariantInput || !modalSubmit) return;
        const variantId = parseInt(modalVariantInput.value, 10);
        if (!variantId) return;

        const payload = {
          id: variantId,
          quantity: 1
        };

        if (modalSellingPlanInput && modalSellingPlanInput.value) {
          payload.selling_plan = parseInt(modalSellingPlanInput.value, 10);
        }

        modalSubmit.disabled = true;
        try {
          await addToCart(payload);
          updateCardBadge();
          updateHeaderCartCount(1);
          showAddToast(activeCartButton);
          closePlanModal();
        } catch (error) {
          window.location.href = '/cart';
        } finally {
          modalSubmit.disabled = false;
        }
      });
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customers-addresses"]) return;
  try {
    
  (function() {
    // Add address
    const addBtn = document.querySelector('[data-add-address]');
    const addForm = document.getElementById('AddAddressForm');
    const cancelAddBtns = document.querySelectorAll('[data-cancel-address]');
    
    if (addBtn && addForm) {
      addBtn.addEventListener('click', function() {
        addForm.style.display = 'block';
        addBtn.style.display = 'none';
      });
      
      cancelAddBtns.forEach(function(btn) {
        btn.addEventListener('click', function() {
          addForm.style.display = 'none';
          addBtn.style.display = 'inline-flex';
        });
      });
    }
    
    // Edit address
    const editBtns = document.querySelectorAll('[data-edit-address]');
    editBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        const addressId = this.getAttribute('data-edit-address');
        const editForm = document.getElementById('EditAddress_' + addressId);
        const addressDisplay = this.closest('.customer-addresses__section').querySelector('.customer-addresses__address');
        
        if (editForm) {
          editForm.style.display = 'block';
          if (addressDisplay) addressDisplay.style.display = 'none';
        }
      });
    });
    
    // Cancel edit
    const cancelEditBtns = document.querySelectorAll('[data-cancel-edit]');
    cancelEditBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        const addressId = this.getAttribute('data-cancel-edit');
        const editForm = document.getElementById('EditAddress_' + addressId);
        const addressDisplay = this.closest('.customer-addresses__section').querySelector('.customer-addresses__address');
        
        if (editForm) {
          editForm.style.display = 'none';
          if (addressDisplay) addressDisplay.style.display = 'block';
        }
      });
    });
    
    // Delete address
    const deleteBtns = document.querySelectorAll('[data-delete-address]');
    deleteBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (confirm('Are you sure you want to delete this address?')) {
          const formId = this.getAttribute('data-form-id');
          const form = document.getElementById(formId);
          if (form) form.submit();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customers-login"]) return;
  try {
    
  (function() {
    const recoverLink = document.getElementById('RecoverPassword');
    const hideRecover = document.getElementById('HideRecoverPassword');
    const recoverSection = document.getElementById('recover');
    const loginForm = document.querySelector('.customer-login__form');
    const registerSection = document.querySelector('.customer-login__register');
    
    if (recoverLink && recoverSection) {
      recoverLink.addEventListener('click', function(e) {
        e.preventDefault();
        recoverSection.style.display = 'block';
        if (loginForm) loginForm.style.display = 'none';
        if (registerSection) registerSection.style.display = 'none';
      });
    }
    
    if (hideRecover && recoverSection) {
      hideRecover.addEventListener('click', function(e) {
        e.preventDefault();
        recoverSection.style.display = 'none';
        if (loginForm) loginForm.style.display = 'flex';
        if (registerSection) registerSection.style.display = 'block';
      });
    }
    
    // Check if URL has #recover hash
    if (window.location.hash === '#recover' && recoverSection) {
      recoverSection.style.display = 'block';
      if (loginForm) loginForm.style.display = 'none';
      if (registerSection) registerSection.style.display = 'none';
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function() {
    const header = document.querySelector('[data-header]');
    const searchInline = document.querySelector('[data-search-inline]');
    const searchToggle = document.querySelector('[data-search-toggle]');
    const searchField = document.querySelector('[data-search-field]');
    const searchInput = searchInline?.querySelector('input');
    
    // Mobile menu elements
    const menuToggle = document.querySelector('[data-menu-toggle]');
    const mobileMenu = document.querySelector('[data-mobile-menu]');
    const menuCloseButtons = document.querySelectorAll('[data-menu-close]');

    if (!header) return;

    // Keep global header offset vars in sync with actual rendered header height.
    // This ensures page content drops only as much as needed (with or without
    // a visible announcement bar).
    function updateHeaderOffsetVars() {
      const measuredHeight = header.offsetHeight || 0;

      if (measuredHeight > 0) {
        document.documentElement.style.setProperty('--header-height', measuredHeight + 'px');
        document.documentElement.style.setProperty('--header-height-mobile', measuredHeight + 'px');
      }
    }
    
    // Mobile menu functionality
    if (menuToggle && mobileMenu) {
      menuToggle.addEventListener('click', function() {
        mobileMenu.classList.add('mobile-menu--open');
        menuToggle.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
      });
      
      menuCloseButtons.forEach(function(btn) {
        btn.addEventListener('click', function() {
          mobileMenu.classList.remove('mobile-menu--open');
          menuToggle.setAttribute('aria-expanded', 'false');
          document.body.style.overflow = '';
        });
      });
      
      // Close on escape key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && mobileMenu.classList.contains('mobile-menu--open')) {
          mobileMenu.classList.remove('mobile-menu--open');
          menuToggle.setAttribute('aria-expanded', 'false');
          document.body.style.overflow = '';
        }
      });
    }

    updateHeaderOffsetVars();
    window.addEventListener('resize', updateHeaderOffsetVars);
    window.addEventListener('load', updateHeaderOffsetVars);

    let lastScrollY = window.scrollY;
    let ticking = false;
    const scrollThreshold = 100;

    function updateHeader() {
      const currentScrollY = window.scrollY;

      // Add scrolled state when scrolled (changes background and button)
      if (currentScrollY > 10) {
        header.classList.add('header--scrolled');
      } else {
        header.classList.remove('header--scrolled');
      }

      // Only apply hide/show after passing threshold
      if (currentScrollY > scrollThreshold) {
        if (currentScrollY > lastScrollY) {
          // Scrolling down - hide header
          header.classList.add('header--hidden');
        } else {
          // Scrolling up - show header
          header.classList.remove('header--hidden');
        }
      } else {
        // Above threshold - always show
        header.classList.remove('header--hidden');
      }

      lastScrollY = currentScrollY;
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(updateHeader);
        ticking = true;
      }
    });

    // Inline search functionality
    if (searchToggle && searchInline) {
      searchToggle.addEventListener('click', function(e) {
        e.preventDefault();
        const isOpen = searchInline.classList.contains('header__search-inline--open');
        
        if (!isOpen) {
          // Open the search
          searchInline.classList.add('header__search-inline--open');
          searchToggle.setAttribute('aria-expanded', 'true');
          if (searchInput) {
            setTimeout(function() {
              searchInput.focus();
            }, 100);
          }
        } else {
          // Submit the form if there's a search term
          if (searchInput && searchInput.value.trim()) {
            searchInline.submit();
          }
        }
      });

      // Close on click outside
      document.addEventListener('click', function(e) {
        if (searchInline.classList.contains('header__search-inline--open')) {
          if (!searchInline.contains(e.target)) {
            searchInline.classList.remove('header__search-inline--open');
            searchToggle.setAttribute('aria-expanded', 'false');
          }
        }
      });

      // Close on escape
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && searchInline.classList.contains('header__search-inline--open')) {
          searchInline.classList.remove('header__search-inline--open');
          searchToggle.setAttribute('aria-expanded', 'false');
        }
      });
    }

    // Dropdown accessibility
    const dropdownTriggers = document.querySelectorAll('.header__dropdown-trigger');
    dropdownTriggers.forEach(trigger => {
      trigger.addEventListener('click', function() {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', !isExpanded);
      });

      // Close on click outside
      document.addEventListener('click', function(e) {
        if (!trigger.closest('.header__dropdown').contains(e.target)) {
          trigger.setAttribute('aria-expanded', 'false');
        }
      });
    });

    // Announcement bar functionality
    const announcementBars = header.querySelectorAll('.announcement-bar');
    const now = Date.now();
    
    announcementBars.forEach(function(bar) {
      const bannerId = bar.dataset.bannerId;
      const startTime = parseInt(bar.dataset.startTime) || 0;
      const endTime = parseInt(bar.dataset.endTime) || Infinity;
      const isDismissible = bar.hasAttribute('data-dismissible');
      
      // Check scheduling
      if (startTime && now < startTime) {
        bar.classList.add('announcement-bar--hidden');
        updateHeaderOffsetVars();
        return;
      }
      if (endTime && now > endTime) {
        bar.classList.add('announcement-bar--hidden');
        updateHeaderOffsetVars();
        return;
      }
      
      // Check if dismissed
      if (isDismissible) {
        const dismissed = localStorage.getItem('banner_dismissed_' + bannerId);
        if (dismissed) {
          bar.classList.add('announcement-bar--hidden');
          updateHeaderOffsetVars();
          return;
        }
      }
    });
    
    // Handle dismiss buttons
    const dismissBtns = header.querySelectorAll('[data-dismiss-banner]');
    dismissBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        const bannerId = this.dataset.dismissBanner;
        const bar = header.querySelector('[data-banner-id="' + bannerId + '"]');
        if (bar) {
          bar.classList.add('announcement-bar--hidden');
          localStorage.setItem('banner_dismissed_' + bannerId, 'true');
          updateHeaderOffsetVars();
        }
      });
    });
    
    // Handle copy code buttons
    const copyButtons = header.querySelectorAll('[data-copy-code]');
    copyButtons.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const code = this.dataset.copyCode;
        
        navigator.clipboard.writeText(code).then(function() {
          btn.classList.add('is-copied');
          setTimeout(function() {
            btn.classList.remove('is-copied');
          }, 2000);
        }).catch(function() {
          // Fallback for older browsers
          const textarea = document.createElement('textarea');
          textarea.value = code;
          textarea.style.position = 'fixed';
          textarea.style.opacity = '0';
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand('copy');
          document.body.removeChild(textarea);
          
          btn.classList.add('is-copied');
          setTimeout(function() {
            btn.classList.remove('is-copied');
          }, 2000);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  var passwordForm = document.querySelector('[data-password-form]');

  if (passwordForm) {
    var params = new URLSearchParams(window.location.search);
    var passwordParam = params.get('password');
    if (params.has('password') && (passwordParam === '' || passwordParam === 'true' || passwordParam === '1')) {
      passwordForm.hidden = false;
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-blood-test-whats-tested"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const section = document.querySelector('.whats-tested');
    if (!section) return;

    section.querySelectorAll('[data-modal-open]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const modalId = this.getAttribute('data-modal-open');
        const modal = document.getElementById(modalId);
        if (modal) {
          modal.hidden = false;
          modal.querySelector('.whats-tested__modal-content').focus();
          document.body.style.overflow = 'hidden';
        }
      });
    });

    section.querySelectorAll('[data-modal-close]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const modalId = this.getAttribute('data-modal-close');
        const modal = document.getElementById(modalId);
        if (modal) {
          modal.hidden = true;
          document.body.style.overflow = '';
        }
      });
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.whats-tested__modal').forEach(function(modal) {
          if (!modal.hidden) {
            modal.hidden = true;
            document.body.style.overflow = '';
          }
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-dna-discover"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const section = document.querySelector('.dna-discover');
    if (!section) return;

    section.querySelectorAll('[data-modal-open]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        const modalId = this.getAttribute('data-modal-open');
        const modal = document.getElementById(modalId);
        if (modal) {
          modal.hidden = false;
          modal.querySelector('.dna-discover__modal-content').focus();
          document.body.style.overflow = 'hidden';
        }
      });
    });

    section.querySelectorAll('[data-modal-close]').forEach(function(el) {
      el.addEventListener('click', function() {
        const modalId = this.getAttribute('data-modal-close');
        const modal = document.getElementById(modalId);
        if (modal) {
          modal.hidden = true;
          document.body.style.overflow = '';
        }
      });
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('.dna-discover__modal').forEach(function(modal) {
          if (!modal.hidden) {
            modal.hidden = true;
            document.body.style.overflow = '';
          }
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-essential-one-made-for-you"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var wrappers = document.querySelectorAll('.made-for-you__carousel-wrapper');
    wrappers.forEach(function(wrapper) {
      var track = wrapper.querySelector('[data-made-for-you-track]');
      var prevBtn = wrapper.querySelector('[data-made-for-you-prev]');
      var nextBtn = wrapper.querySelector('[data-made-for-you-next]');
      var dotsContainer = wrapper.closest('.made-for-you__inner').querySelector('[data-made-for-you-dots]');

      if (!track) return;

      var slides = track.querySelectorAll('.made-for-you__slide');
      var totalSlides = slides.length;

      if (totalSlides <= 1) {
        if (prevBtn) prevBtn.style.display = 'none';
        if (nextBtn) nextBtn.style.display = 'none';
        return;
      }

      var getCurrentIndex = function() {
        var scrollLeft = track.scrollLeft;
        var slideWidth = track.offsetWidth;
        return Math.round(scrollLeft / slideWidth);
      };

      var scrollToIndex = function(index) {
        var slideWidth = track.offsetWidth;
        track.scrollTo({ left: index * slideWidth, behavior: 'smooth' });
      };

      var updateUI = function() {
        var index = Math.min(getCurrentIndex(), totalSlides - 1);
        if (prevBtn) prevBtn.disabled = index <= 0;
        if (nextBtn) nextBtn.disabled = index >= totalSlides - 1;
        if (dotsContainer) {
          var dots = dotsContainer.querySelectorAll('.made-for-you__dot');
          dots.forEach(function(dot, i) {
            dot.classList.toggle('made-for-you__dot--active', i === index);
          });
        }
      };

      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          var index = getCurrentIndex();
          scrollToIndex(Math.max(0, index - 1));
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          var index = getCurrentIndex();
          scrollToIndex(Math.min(totalSlides - 1, index + 1));
        });
      }

      if (dotsContainer) {
        dotsContainer.querySelectorAll('.made-for-you__dot').forEach(function(dot) {
          dot.addEventListener('click', function() {
            var index = parseInt(this.getAttribute('data-made-for-you-dot'), 10);
            scrollToIndex(index);
          });
        });
      }

      track.addEventListener('scroll', function() {
        clearTimeout(track._scrollTimeout);
        track._scrollTimeout = setTimeout(updateUI, 50);
      });

      updateUI();
      window.addEventListener('resize', updateUI);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-nutrition"] && !Shopify.designMode) return;
  try {
    
  // Expand/collapse individual nutrient claims
  document.querySelectorAll('[data-expand-btn]').forEach(btn => {
    btn.addEventListener('click', () => {
      const row = btn.closest('[data-nutrient-row]');
      const claimRow = row.nextElementSibling;
      if (!claimRow || !claimRow.hasAttribute('data-claim-row')) return;
      
      const isExpanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', !isExpanded);
      claimRow.hidden = isExpanded;
    });
  });
  
  // Show more/less nutrients
  const showMoreBtn = document.querySelector('[data-show-more]');
  if (showMoreBtn) {
    showMoreBtn.addEventListener('click', () => {
      const isExpanded = showMoreBtn.getAttribute('aria-expanded') === 'true';
      const hiddenRows = document.querySelectorAll('[data-hidden-nutrient]');
      const textEl = showMoreBtn.querySelector('[data-show-more-text]');
      
      hiddenRows.forEach(row => {
        row.classList.toggle('product-nutrition__row--hidden', isExpanded);
        // Also handle claim rows that follow hidden nutrient rows
        const nextRow = row.nextElementSibling;
        if (nextRow && nextRow.hasAttribute('data-claim-row')) {
          nextRow.classList.toggle('product-nutrition__row--hidden', isExpanded);
        }
      });
      
      showMoreBtn.setAttribute('aria-expanded', !isExpanded);
      textEl.textContent = isExpanded ? `Show more (${hiddenRows.length})` : 'Show less';
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shared-faqs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const faqSections = document.querySelectorAll('.shared-faqs');
    
    faqSections.forEach(function(section) {
      const tabs = section.querySelectorAll('[data-faq-tab]');
      const panels = section.querySelectorAll('[data-faq-panel]');
      
      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          const tabIndex = this.getAttribute('data-faq-tab');
          
          // Update tabs within this section only
          tabs.forEach(function(t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          this.classList.add('is-active');
          this.setAttribute('aria-selected', 'true');
          
          // Update panels within this section only
          panels.forEach(function(panel) {
            panel.classList.remove('is-active');
            panel.setAttribute('hidden', '');
          });
          
          const activePanel = section.querySelector('[data-faq-panel="' + tabIndex + '"]');
          if (activePanel) {
            activePanel.classList.add('is-active');
            activePanel.removeAttribute('hidden');
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shared-image-carousel-with-text"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    var wrappers = document.querySelectorAll('.image-with-text-carousel__wrapper');
    wrappers.forEach(function(wrapper) {
      var track = wrapper.querySelector('[data-carousel-track]');
      var prevBtn = wrapper.querySelector('[data-carousel-prev]');
      var nextBtn = wrapper.querySelector('[data-carousel-next]');
      var dotsContainer = wrapper.closest('.image-with-text-carousel__media').querySelector('[data-carousel-dots]');

      if (!track) return;

      var slides = track.querySelectorAll('.image-with-text-carousel__slide');
      var totalSlides = slides.length;

      if (totalSlides <= 1) {
        if (prevBtn) prevBtn.style.display = 'none';
        if (nextBtn) nextBtn.style.display = 'none';
        return;
      }

      var getCurrentIndex = function() {
        var scrollLeft = track.scrollLeft;
        var slideWidth = track.offsetWidth;
        return Math.round(scrollLeft / slideWidth);
      };

      var scrollToIndex = function(index) {
        var slideWidth = track.offsetWidth;
        track.scrollTo({ left: index * slideWidth, behavior: 'smooth' });
      };

      var updateUI = function() {
        var index = Math.min(getCurrentIndex(), totalSlides - 1);
        if (prevBtn) prevBtn.disabled = index <= 0;
        if (nextBtn) nextBtn.disabled = index >= totalSlides - 1;
        if (dotsContainer) {
          var dots = dotsContainer.querySelectorAll('.image-with-text-carousel__dot');
          dots.forEach(function(dot, i) {
            dot.classList.toggle('image-with-text-carousel__dot--active', i === index);
          });
        }
      };

      if (prevBtn) {
        prevBtn.addEventListener('click', function() {
          var idx = getCurrentIndex();
          scrollToIndex(Math.max(0, idx - 1));
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function() {
          var idx = getCurrentIndex();
          scrollToIndex(Math.min(totalSlides - 1, idx + 1));
        });
      }

      track.addEventListener('scroll', updateUI);
      updateUI();

      if (dotsContainer) {
        var dots = dotsContainer.querySelectorAll('.image-with-text-carousel__dot');
        dots.forEach(function(dot, i) {
          dot.addEventListener('click', function() {
            scrollToIndex(i);
          });
        });
      }

      window.addEventListener('resize', updateUI);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shared-video"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const wraps = document.querySelectorAll('.video-section__wrap--youtube');
    wraps.forEach(function(wrap) {
      const videoId = wrap.getAttribute('data-video-id');
      const playBtn = wrap.querySelector('.video-section__play');
      const iframe = wrap.querySelector('.video-section__iframe iframe');
      if (!videoId || !playBtn || !iframe) return;

      playBtn.addEventListener('click', function() {
        iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1';
        wrap.classList.add('video-section__wrap--playing');
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
